/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputCriteriaMultiSelectionComponent} from './input-criteria-multi-selection.component';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {LoadingSpinnerModule} from '../../../loading/loading-spinner/loading-spinner.module';
import {FormsModule} from '@angular/forms';
import {PipesModule} from '../../../pipes/pipes.module';

@NgModule({
    declarations: [
        InputCriteriaMultiSelectionComponent
    ],
    exports: [
        InputCriteriaMultiSelectionComponent
    ],
    imports: [
        CommonModule,
        NgbDropdownModule,
        LoadingSpinnerModule,
        FormsModule,
        PipesModule
    ]
})
export class InputCriteriaMultiSelectionModule {
}
